module.exports = "/static/Images/es/Five.png";